import React from 'react'
import { ReactComponent as Icon } from "../assets/svg/nothing-found.svg"
import { IUnauthorizedBlockButton } from './UnauthorizedBlock'
import { useNavigate } from 'react-router-dom'
import { Button } from '@mui/material'

interface IProps {
    title?: string,
    message?: string,
    buttons?: IUnauthorizedBlockButton[]
}

export default function NothingFound(props: IProps) {

    const { title, message, buttons } = props

    const navigate = useNavigate()

    return(
        <div className="nothing-found-block">
            <div className="content-of-nothing-found-block">

                <Icon />
                <h3>{title ? title : "Nothing..."}</h3>
                <p>{message ? message : "Sorry, we couldn’t find anything :("}</p>

                {buttons && buttons.length > 0 && (
                    <div className="buttons-of-nothing-found-block">
                        <div className="content-of-buttons-of-nothing-found-block">
                            {buttons.map((button, index) => {

                                const onClick = () => {
                                    if (button.onClick){
                                        button.onClick()
                                    }

                                    if (button.link){
                                        navigate(button.link)
                                    }
                                }

                                return <Button disabled={button.disabled} color={button.color ? button.color : "primary"} onClick={() => onClick()} className={button.addClassName ? `general-button admin-style ${button.addClassName}` : "general-button admin-style"} variant={button.variant ? button.variant : "contained"}>{button.label}</Button>
                            })}
                        </div>
                    </div>
                )}

            </div>
        </div>
    )
}